/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useState } from "react";
import { theme } from "styles/theme";
import Icon from "uis/Icon";

type ButtonType = "default" | "disabled";

type Props = {
  status?: ButtonType;
  width?: number;
  height?: number;
  onChange?: (isChecked: boolean) => void;

  value?: boolean;
};
export default function CheckBox(props: Props) {
  const { status = "default", width = 24, height = 24, onChange = (checked: boolean) => {} } = props;
  const [checked, setChecked] = useState<boolean>(false);

  const containerStyle = () => {
    if (props.value !== undefined) {
      switch (status) {
        case "default":
          return `background-color: ${props.value ? theme.primary500 : theme.primary50}; 
                            border-color: ${!props.value ? theme.primary100 : theme.primary500}`;
        case "disabled":
          return `background-color: ${props.value ? theme.neutral200 : theme.neutral50}
                            border-color: ${!props.value ? theme.neutral100 : theme.neutral200}`;
      }
    }
    switch (status) {
      case "default":
        return `background-color: ${checked ? theme.primary500 : theme.primary50}; 
                        border-color: ${!checked ? theme.primary100 : theme.primary500}`;
      case "disabled":
        return `background-color: ${checked ? theme.neutral200 : theme.neutral50}
                        border-color: ${!checked ? theme.neutral100 : theme.neutral200}`;
    }
  };
  return (
    <div
      onClick={() => {
        if (props.value !== undefined) {
          onChange(!props.value);
        }

        if (props.value === undefined) {
          onChange(!checked);
          setChecked(!checked);
        }
      }}
      css={css`
        width: ${width}px;
        height: ${height}px;
        border-radius: 5px;
        border: 1px solid;
        ${containerStyle()};
      `}
    >
      {props.value === undefined && checked && <Icon name="check" color="white" width={width} height={height} />}
      {props.value !== undefined && props.value && <Icon name="check" color="white" width={width} height={height} />}
    </div>
  );
}
